
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitokolhapurcab() {



    const cardData =
    {
        keyword: ' Mumbai to Kolhapur Cab ',
        heading: 'Deva Cabs: Mumbai to Kolhapur Cab ',
        headingDescription: 'Deva Cabs offers dependable and comfortable cab services from Mumbai to Kolhapur, ideal for family travel, business trips, and pilgrimages. Covering a distance of around 380 km, our well-maintained cabs ensure a smooth and safe ride through the highway route. Whether you choose a Sedan, SUV, or Innova Crysta, each vehicle comes with a professional driver and ample comfort for long-distance travel. With fixed pricing, on-time service, and 24/7 availability, Deva Cabs makes your Mumbai to Kolhapur journey stress-free and convenient.',

        top: 'Top Places to Visit in Kolhapur with Deva Cabs',

"topPlaces": [
  {
    "title": "Mahalakshmi Temple",
    "location": "Kolhapur, Maharashtra",
    "description": "The Mahalakshmi Temple, also known as Ambabai Temple, is one of the Shakti Peethas and a major pilgrimage site in Maharashtra. Dedicated to Goddess Lakshmi, the temple features stunning stone carvings, spiritual energy, and daily rituals that attract thousands of devotees from across India."
  },
  {
    "title": "Rankala Lake",
    "location": "Kolhapur, Maharashtra",
    "description": "Rankala Lake is a scenic spot perfect for evening strolls, boating, and horse rides along the promenade. Surrounded by gardens and temples, the lake offers beautiful sunset views and a peaceful atmosphere for families, photographers, and nature lovers alike."
  },
  {
    "title": "New Palace Museum",
    "location": "Kolhapur, Maharashtra",
    "description": "The New Palace, built in Indo-Saracenic style, houses the Shree Chhatrapati Shahu Museum. It features royal memorabilia, weapons, artifacts, and a taxidermy collection. The palace architecture and the lush grounds around it make it a must-visit for history enthusiasts."
  },
  {
    "title": "Jyotiba Temple",
    "location": "Wadi Ratnagiri, Kolhapur, Maharashtra",
    "description": "Situated on a hilltop around 18 km from Kolhapur, the Jyotiba Temple is dedicated to Lord Jyotiba, a form of Lord Shiva. It’s especially vibrant during the annual yatra (pilgrimage), when thousands of devotees throw gulal (colored powder) and celebrate with devotion and grandeur."
  },
  {
    "title": "Panhala Fort",
    "location": "Panhala, Kolhapur District, Maharashtra",
    "description": "Panhala Fort is a majestic hill fort that played a crucial role in Maratha history. It offers panoramic views, ancient bastions, and monuments like the Teen Darwaza and Sajja Kothi. It's a great destination for trekking, history lovers, and monsoon travelers."
  },
  {
    "title": "Kopeshwar Temple",
    "location": "Khidrapur, Kolhapur District, Maharashtra",
    "description": "Kopeshwar Temple is an architectural gem located near Kolhapur, dedicated to Lord Shiva. Known for its intricately carved sculptures and detailed pillars, this lesser-known temple is a peaceful and spiritual stop for those exploring heritage and culture."
  },
  {
    "title": "Shalini Palace",
    "location": "Kolhapur, Maharashtra",
    "description": "Shalini Palace, once a royal residence, is a heritage structure situated on the banks of Rankala Lake. Built from black stone and Italian marble, the palace features exquisite glasswork and architecture. Although currently closed for operations, it remains a picturesque landmark."
  },
  {
    "title": "Kaneri Math – Siddhagiri Gramjivan Museum",
    "location": "Kaneri, Kolhapur District, Maharashtra",
    "description": "This open-air museum portrays life in a self-sufficient Indian village before industrialization. With life-size sculptures depicting traditional occupations, tools, and customs, it’s a fascinating educational spot for all age groups, blending culture with history."
  },
  {
    "title": "Dajipur Bison Sanctuary",
    "location": "Radhanagari, Kolhapur District, Maharashtra",
    "description": "Also known as Radhanagari Wildlife Sanctuary, this forest reserve is home to the Indian bison (gaur), leopards, deer, and numerous bird species. A paradise for wildlife enthusiasts and trekkers, it offers jungle safaris and eco-tourism opportunities amidst the Western Ghats."
  },
  {
    "title": "Town Hall Museum",
    "location": "Kolhapur, Maharashtra",
    "description": "Located in a colonial-era building, the Town Hall Museum showcases artifacts from the Satavahana to Maratha periods. Exhibits include coins, sculptures, paintings, and weapons, making it a great place to explore Kolhapur's rich historical and cultural heritage."
  }
],



"services": [
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Travel comfortably from Mumbai to Kolhapur with Deva Cabs’ reliable outstation taxi service. Covering a distance of over 375 km, our cabs ensure a safe and smooth journey whether for pilgrimage, business, or leisure. Enjoy door-to-door pickup, professional drivers, and a choice of vehicles including sedans, SUVs, and premium cars for a hassle-free long-distance travel experience."
  },
  {
    "name": "One-way cab Mumbai to Kolhapur",
    "description": "Deva Cabs offers cost-effective one-way cab services from Mumbai to Kolhapur. Ideal for travelers who don’t require a return trip, this service includes well-maintained vehicles, experienced chauffeurs, and on-time service. No return fare means big savings on single-direction travel — perfect for students, solo travelers, and business guests."
  },
  {
    "name": "Mumbai to Kolhapur taxi service",
    "description": "Looking for a dependable taxi from Mumbai to Kolhapur? Deva Cabs provides clean, comfortable, and GPS-enabled cabs suited for the long journey. Whether it’s a day trip or an extended visit, our drivers ensure your comfort and safety with smooth navigation through highways and ghats."
  },
  {
    "name": "Book cab online Mumbai to Kolhapur",
    "description": "Book your Mumbai to Kolhapur cab online within minutes. Deva Cabs’ digital platform allows for instant booking, transparent pricing, and secure payment options. Get real-time updates, vehicle options, and full control over your trip planning — anytime, anywhere."
  },
  {
    "name": "SUV cab Mumbai to Kolhapur",
    "description": "Travel with comfort and space in our powerful SUV cabs for the Mumbai to Kolhapur route. Ideal for families or small groups, our SUVs offer extra legroom, strong suspension, and plenty of luggage space — perfect for long-distance journeys on mixed terrain."
  },
  {
    "name": "Luxury Kolhapur cab from Mumbai",
    "description": "Experience top-tier travel with Deva Cabs’ luxury cab service to Kolhapur from Mumbai. Choose from high-end sedans or executive SUVs with plush interiors, AC, and premium comfort. Ideal for VIPs, couples, or anyone wanting a relaxing, premium long ride."
  },
  {
    "name": "Chauffeur-driven Kolhapur taxi Mumbai",
    "description": "Sit back and enjoy your journey with our chauffeur-driven Kolhapur taxis from Mumbai. Our well-trained, courteous drivers ensure safe navigation, comfortable stops, and a smooth ride throughout. Ideal for those who value service, safety, and professionalism on the road."
  },
  {
    "name": "Round trip cab Mumbai to Kolhapur",
    "description": "Heading to Kolhapur for a short trip? Deva Cabs offers round trip taxi packages from Mumbai with flexible return timings and cost-efficient pricing. Great for business visits, family functions, or short getaways — our cabs stay with you and ensure timely return journeys."
  },
  {
    "name": "Family cab hire Mumbai to Kolhapur",
    "description": "Traveling with kids or elders? Deva Cabs provides family-friendly taxi options with spacious vehicles, clean interiors, and helpful drivers. Our family cabs from Mumbai to Kolhapur are designed for safe, comfortable, and memorable long drives with your loved ones."
  },
  {
    "name": "AC cab Mumbai to Kolhapur",
    "description": "Escape Mumbai’s heat and enjoy a cool ride with our fully air-conditioned cabs to Kolhapur. Whether it’s summer or humid monsoons, our AC vehicles keep the cabin pleasant throughout the long highway journey, ensuring a refreshing travel experience."
  },
  {
    "name": "Mumbai to Kolhapur corporate cab",
    "description": "For professionals and business travelers, Deva Cabs offers corporate cab services to Kolhapur from Mumbai with billing, invoicing, and executive-grade service. Our corporate rides include Wi-Fi-enabled vehicles, punctual drivers, and top-notch comfort for work on the move."
  },
  {
    "name": "Long distance cab Mumbai to Kolhapur",
    "description": "Cover the long stretch between Mumbai and Kolhapur with comfort and reliability using our long-distance cab services. Our vehicles are equipped for endurance, safety, and comfort, with professional drivers who specialize in highway travel across Maharashtra."
  },
  {
    "name": "Premium cab hire Mumbai to Kolhapur",
    "description": "Looking for something more refined? Book a premium cab from Mumbai to Kolhapur with Deva Cabs. Expect superior interiors, enhanced legroom, personalized driver service, and unmatched road comfort — ideal for special occasions or important guests."
  },
  {
    "name": "Mumbai to Kolhapur outstation cab",
    "description": "Deva Cabs provides trusted outstation cab services from Mumbai to Kolhapur, perfect for pilgrimages, family trips, or cultural visits. With fixed packages, one-way or round-trip options, and route knowledge, our outstation cabs make every long ride enjoyable and worry-free."
  },
  {
    "name": "Affordable Mumbai to Kolhapur cab",
    "description": "Travel smart with our affordable cab service to Kolhapur from Mumbai. Deva Cabs offers economical pricing without compromising on quality or safety. Perfect for budget travelers who want a reliable and comfortable journey at the best price."
  }
],
"tableData": [
  ["Mumbai to Kolhapur Cab", "-One-way cab Mumbai to Kolhapur"],
  ["Mumbai to Kolhapur taxi service", "-Book cab online Mumbai to Kolhapur"],
  ["SUV cab Mumbai to Kolhapur", "-Luxury Kolhapur cab from Mumbai"],
  ["Chauffeur-driven Kolhapur taxi Mumbai", "-Round trip cab Mumbai to Kolhapur"],
  ["Family cab hire Mumbai to Kolhapur", "-AC cab Mumbai to Kolhapur"],
  ["Mumbai to Kolhapur corporate cab", "-Long distance cab Mumbai to Kolhapur"],
  ["Premium cab hire Mumbai to Kolhapur", "-Mumbai to Kolhapur outstation cab"],
  ["Affordable Mumbai to Kolhapur cab", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Kolhapur Cab Service",
    "WhyChoosedescription": "Our Mumbai to Kolhapur cab service is designed for travelers seeking dependable and on-time transportation across long distances. Whether you’re traveling for business, attending a family function, visiting the Mahalaxmi Temple, or exploring Kolhapur’s culture, we guarantee timely pickups, courteous drivers, and consistent route coordination for a stress-free experience over this 8–10 hour journey."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long-Distance Travel",
    "WhyChoosedescription": "Comfort matters most during long road trips. Our cabs are equipped with comfortable seats, air conditioning, smooth suspension, and plenty of luggage space—making the 375+ km journey pleasant and relaxing. Whether you choose a sedan, SUV, or luxury model, every vehicle is cleaned, inspected, and tailored for your comfort so you arrive in Kolhapur refreshed and ready."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with the Mumbai-Kolhapur Route",
    "WhyChoosedescription": "Our drivers have years of experience navigating the Mumbai–Pune Expressway and NH48 all the way to Kolhapur. They know where to stop for fuel, food, and rest, and they handle highway driving with confidence and care. Trained in long-distance and safe driving techniques, they’ll make your journey smooth, informative, and secure—no matter what time you travel."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer fair, upfront pricing with no hidden costs. The quote includes tolls, driver allowance, fuel charges, and taxes—so you’ll never encounter surprise fees. Our transparent model ensures that you know what you’re paying for, helping you budget accurately for both personal and business trips to Kolhapur."
  },
  {
    "WhyChooseheading": "24/7 Availability for Early Morning or Late-Night Travel",
    "WhyChoosedescription": "Whether you’re leaving Mumbai in the early hours or arriving in Kolhapur at night, our cabs are available round-the-clock. We operate 24/7 to accommodate train arrivals, temple visit timings, or urgent travel needs. With flexible scheduling, you can plan your trip to Kolhapur entirely around your own convenience."
  },
  {
    "WhyChooseheading": "Quick and Easy Online Booking Process",
    "WhyChoosedescription": "Booking your Mumbai to Kolhapur cab is fast and seamless. Simply choose your preferred car, enter travel details, and confirm. You’ll receive instant booking confirmation, fare breakdown, driver contact info, and customer support access—making your entire experience hassle-free and reliable from start to finish."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicles with Safety Checks",
    "WhyChoosedescription": "All our cabs undergo routine inspections and servicing to ensure a safe ride, especially for long-distance travel. Vehicles are sanitized, fitted with seat belts, GPS, and emergency kits, and our drivers strictly follow road safety guidelines. You can trust us to prioritize your security throughout the journey to Kolhapur."
  },
  {
    "WhyChooseheading": "Customized Travel Solutions to Suit Your Needs",
    "WhyChoosedescription": "Need a one-way drop, round trip, multi-city tour, or stopovers on the way? We offer fully customizable travel packages to Kolhapur to suit families, corporate teams, solo travelers, and pilgrims. Whether you're traveling with elders, children, or a lot of luggage, we adjust the trip to match your unique requirements."
  }
]






    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Kolhapur with Deva Cabs?",
    answer: "Yes, Deva Cabs offers safe and comfortable cab services from Mumbai to Kolhapur for business, personal, or family travel."
  },
  {
    question: "How long does the journey take from Mumbai to Kolhapur by cab?",
    answer: "The trip usually takes around 7 to 9 hours depending on traffic and road conditions."
  },
  {
    question: "What vehicle options are available for Mumbai to Kolhapur route?",
    answer: "We offer sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers based on your travel needs and group size."
  },
  {
    question: "Can I schedule my pickup in advance for a Mumbai to Kolhapur trip?",
    answer: "Yes, advance booking is available through our website, mobile app, or customer support for timely pickup."
  },
  {
    question: "Are one-way cab services available from Mumbai to Kolhapur?",
    answer: "Yes, Deva Cabs provides affordable one-way cab services without the need to pay for return fare."
  },
  {
    question: "Are tolls, driver allowance, and parking charges included in the fare?",
    answer: "These charges are typically extra and will be clearly mentioned during the booking process to ensure transparency."
  },
  {
    question: "Is the cab service available early morning or late night?",
    answer: "Yes, our Mumbai to Kolhapur cab service is available 24/7 to accommodate any travel schedule."
  },
  {
    question: "Is it safe to travel long-distance alone in your cabs?",
    answer: "Absolutely. Our drivers are police-verified, experienced, and trained for safety, making solo and female travel secure."
  },
  {
    question: "Can I book a round-trip cab from Mumbai to Kolhapur?",
    answer: "Yes, we offer flexible round-trip packages with same-day or extended return options at competitive rates."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Kolhapur cab services?",
    answer: "Deva Cabs provides clean vehicles, skilled drivers, punctual service, and transparent pricing for a stress-free travel experience."
  }
];

const testimonialData = [
  {
    id: 37,
    name: 'Mr. Pravin Jadhav',
    role: 'Business Traveler',
    review: 'I booked a cab from Mumbai to Kolhapur for a business trip. The driver was punctual, the car was neat, and the journey was smooth. Great service!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 38,
    name: 'Ms. Manisha Rane',
    role: 'Family Traveler',
    review: 'Deva Cabs made our trip from Mumbai to Kolhapur stress-free. The vehicle was clean and the driver was very professional. Highly recommended!',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Kolhapur Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-kolhapur-cab.jpg", // Replace with actual image
  "description": "Book Mumbai to Kolhapur cab with Deva Cabs for a safe and comfortable journey. AC hatchbacks, sedans, SUVs, and tempo travellers available for one-way and round trip. Affordable fares and 24/7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "3180"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4499",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-kolhapur-cab"
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Kolhapur Cab | One Way & Round Trip Taxi - Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Kolhapur cab with Deva Cabs. One-way and round trip taxi service with experienced drivers and clean vehicles. Choose from hatchback, sedan, SUV, or tempo traveller for a comfortable road trip." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Kolhapur Cab, Cab from Mumbai to Kolhapur, One Way Taxi Mumbai to Kolhapur, Kolhapur Cab Service, Mumbai to Kolhapur Car Rental, Deva Cabs Mumbai to Kolhapur, SUV Sedan Tempo Traveller Mumbai to Kolhapur, Online Cab Booking Mumbai Kolhapur, Affordable Taxi Mumbai to Kolhapur, Round Trip Taxi Mumbai Kolhapur" 
  />
  <link rel="canonical" href="https://devacab.com/mumbai-to-kolhapur-cab" />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/27.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitokolhapurcab;